import PropTypes from 'prop-types';
import styles from './FJRatioChoose.module.less';
import ArrowIcon from '../../../assets/svg/button-right-2.svg?react';
import FJSideModel from '../../../common/components/FJSideModel/FJSideModel';
import { useState } from 'react';
import FJVerticalScroller from '../../../common/components/FJScroller/FJVerticalScroller';
import CheckIcon from '../../../assets/svg/choose.svg?react';
import classNames from 'classnames';
import FJLocalStore from '../../../store/FJLocalStore';

const FJRatioChoose = props => {
    const { currentRatio, changeRatio, list } = props;
    const [showSideModel, setShowSideModel] = useState(false);

    const curRatioObj = list.find(item => item.name === currentRatio);

    const handleClick = e => {
        e.stopPropagation();
        setShowSideModel(!showSideModel);
    };

    const handleOnMouseDown = e => {
        showSideModel && e.stopPropagation();
    };

    const handleChangeRatio = ratio => {
        changeRatio(ratio);
        setShowSideModel(false);
    };

    return (
        <>
            <div className={styles.ratio_box}>
                <div className={styles.ratio_title}>{FJLocalStore._('aspect-ratio')}</div>
                <div className={styles.ratio_btu} onClick={handleClick} onMouseDown={handleOnMouseDown}>
                    <curRatioObj.icon className={styles.ratio_icon} />
                    {curRatioObj.name}
                    <ArrowIcon className={styles.arrow_icon} />
                </div>
            </div>

            <FJSideModel
                position={{ top: 370, left: 478 }}
                active={showSideModel}
                className={styles.ratio_side_model}
                onClose={() => setShowSideModel(false)}
            >
                <div className={styles.model_ratio_title}>{FJLocalStore._('aspect-ratio')}</div>

                <FJVerticalScroller className={styles.ratio_list_box}>
                    {list.map(item => {
                        return (
                            <div
                                className={classNames(
                                    styles.ratio_item,
                                    item.name === curRatioObj.name && styles.ratio_item_active,
                                )}
                                key={item.name}
                                onClick={() => handleChangeRatio(item.name)}
                            >
                                <item.icon className={styles.ratio_item_icon} />
                                <div className={styles.ratio_item_name}>{item.name}</div>
                                {item.name === curRatioObj.name && <CheckIcon className={styles.check_icon} />}
                            </div>
                        );
                    })}
                </FJVerticalScroller>
            </FJSideModel>
        </>
    );
};

FJRatioChoose.propTypes = {
    currentRatio: PropTypes.string,
    changeRatio: PropTypes.func,
    list: PropTypes.array,
};
export default FJRatioChoose;
